import { Pricing } from "components/pages/Pricing";
import { IFAQ } from "interfaces/faq.interface";
import { fetchFaqs } from "services/contentful";

export default function PricingPage({ faqs }: { faqs: IFAQ[] }) {
  return <Pricing faqs={faqs} />;
}

PricingPage.isNavigationInversed = true;

export async function getStaticProps() {
  const { data } = await fetchFaqs();

  return {
    props: {
      faqs: data,
    },
  };
}
